"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IsWhiteListUser = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var guMember_1 = require("../../model/guMember");
var service_1 = require("../../../library/base/service");
var IsWhiteListUser = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(IsWhiteListUser, _super);
    function IsWhiteListUser() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '用户是否在白名单中';
        _this.code = '300403';
        _this.desc = '用户是否在白名单中';
        _this.requestParams = new guMember_1.IsWhiteListUserRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return IsWhiteListUser;
}(service_1.BaseService));
exports.IsWhiteListUser = IsWhiteListUser;
//# sourceMappingURL=isWhiteListUser.js.map